const type = "REPORTS/";

export const reportsConstants = {
  LISTING_REQUEST: `${type}LISTING_REQUEST`,
  LISTING_SUCCESS: `${type}LISTING_SUCCESS`,
  LISTING_FAILURE: `${type}LISTING_FAILURE`,

  CONFIG_LISTING_REQUEST: `${type}CONFIG_LISTING_REQUEST`,
  CONFIG_LISTING_SUCCESS: `${type}CONFIG_LISTING_SUCCESS`,
  CONFIG_LISTING_FAILURE: `${type}CONFIG_LISTING_FAILURE`,
  
  CONFIG_SAVE_REQUEST: `${type}CONFIG_SAVE_REQUEST`,
  CONFIG_SAVE_SUCCESS: `${type}CONFIG_SAVE_SUCCESS`,
  CONFIG_SAVE_FAILURE: `${type}CONFIG_SAVE_FAILURE`,
  
  CONFIG_DELETE_REQUEST: `${type}CONFIG_DELETE_REQUEST`,
  CONFIG_DELETE_SUCCESS: `${type}CONFIG_DELETE_SUCCESS`,
  CONFIG_DELETE_FAILURE: `${type}CONFIG_DELETE_FAILURE`,

};
